import { render } from "./TitleBlock.vue?vue&type=template&id=2f17a01d&scoped=true"
import script from "./TitleBlock.vue?vue&type=script&lang=js"
export * from "./TitleBlock.vue?vue&type=script&lang=js"

import "./TitleBlock.vue?vue&type=style&index=0&id=2f17a01d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f17a01d"]])

export default __exports__